import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { MobileMenuService } from './services/mobile-menu.service';
import { VersionCheckService } from './services/version-check.service';
import { CookiePolicyService } from './services/cookie-policy.service';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { NgClass } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { TrustPilotComponent } from './components/trust-pilot/trust-pilot.component';
import { FooterComponent } from './components/footer/footer.component';
import { CookiePopupComponent } from './components/cookie-popup/cookie-popup.component';

declare let gtag: (a: string, b: string, c: object) => void;

declare global {
  interface Window {
    Trustpilot: unknown;
    HubSpotConversations: unknown;
    hsConversationsOnReady: unknown;
  }
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [MobileMenuComponent, NgClass, HeaderComponent, RouterOutlet, TrustPilotComponent, FooterComponent, CookiePopupComponent]
})
export class AppComponent implements OnInit {

  title = 'Irish Celtic Jewellery - Handcrafted with love here in Ireland';
  description = 'The finest quality irish celtic jewellery. Celtic Wedding Rings, Celtic Engagement Rings.';

  private platformId = inject(PLATFORM_ID);
  private cookiePolicyService = inject(CookiePolicyService);
  mobileMenuService = inject(MobileMenuService);
  private router = inject(Router);
  private versionCheckService = inject(VersionCheckService);


  ngOnInit(): void {
    this.versionCheckService.initVersionCheck();
    this.cookiePolicyService.check();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.mobileMenuService.closeMenu();
        if (isPlatformBrowser(this.platformId)) {
          window.scroll(0, 0);
          gtag('config', 'G-Z5KK6DP1GT', { page_path: event.urlAfterRedirects });
        }
      }
    });
  }
}
